import {all, call, fork, put, takeEvery} from "redux-saga/effects";
import {fetchIndustrySuccess, fetchIndustryError, addIndustrySuccess, addIndustryError, updateIndustrySuccess, updateIndustryError} from '../actions/Industry';
import { getDocs, addDoc, updateDoc } from 'firebase/services/industry';
import {FETCH_INDUSTRY, ADD_INDUSTRY, UPDATE_INDUSTRY} from 'constants/ActionTypes';

function* fetchIndustryRequest() {
  try {
    const fetchedIndustryList = yield call(getDocs);
    yield put(fetchIndustrySuccess(fetchedIndustryList));
  } catch (error) {
    console.log(error);
    yield put(fetchIndustryError(error));
  }
}


function* addIndustryRequest({ payload: { params } }) {
  try {
    const requests = params.map(param => call(addDoc, {data: param}));
    const result = yield all(requests);
    yield put(addIndustrySuccess(result));
  } catch (error) {
    console.log(error);
    yield put(addIndustryError(error));
  }
}

function* updateIndustryRequest({ params }) {
  try {
    const requests = params.map(param => call(updateDoc, {key: param.key, data: param}));
    const result = yield all(requests);
    yield put(updateIndustrySuccess(result));
  } catch (error) {
    console.log(error);
    yield put(updateIndustryError(error));
  }
}

export function* fetchIndustry() {
  yield takeEvery(FETCH_INDUSTRY, fetchIndustryRequest);
}


export function* addIndustry() {
  yield takeEvery(ADD_INDUSTRY, addIndustryRequest);
}

export function* updateIndustry() {
  yield takeEvery(UPDATE_INDUSTRY, updateIndustryRequest);
}

export default function* rootSaga() {
  yield all([fork(fetchIndustry), fork(addIndustry), fork(updateIndustry)]);
}
